import { Link, Typography } from "@fullscript/aviary-web";
import type { LinkIntentions } from "@fullscript/aviary-web/dist/types/aviary-web/src/components/molecules/Link/Link.web.types";
import { useTranslation } from "react-i18next";

import { useFlippers } from "@shared/context/FlippersContext";
import type { Flipper } from "@shared/types/flipper";
import { l } from "@unauthenticated/shared/locales/i18n";

interface Props {
  flipperName?: Flipper;
  branding?: {
    promptText?: string;
    linkText?: string;
    linkIntention?: LinkIntentions;
  };
  onClick: () => void;
}

const OIDCSignUpLink = ({ flipperName = "iam_academy_signup", branding, onClick }: Props) => {
  const { t } = useTranslation();
  const [flipperEnabled] = useFlippers(flipperName);

  if (!flipperEnabled) return null;

  const promptText = branding?.promptText ?? t(l.signIn.fullscriptAcademy.dontHaveAccount);
  const linkText = branding?.linkText ?? t(l.signIn.fullscriptAcademy.signUp);
  const linkIntention = branding?.linkIntention ?? "accentGreen";

  return (
    <Typography>
      {promptText}{" "}
      <Link data-e2e="oidc-sign-up-link" intention={linkIntention} hideUnderline onClick={onClick}>
        {linkText}
      </Link>
    </Typography>
  );
};

export { OIDCSignUpLink };
